// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2i8yg","label":"SetPasswdForm_label__2cIJl"};